import React from "react";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner } from "@reco-w/core-ui";
import { Namespaces, softwareModel } from "@reco-w/software-models";
import { BackTopBox } from "@reco-w/about-e";

const DataCatalog = [
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "集成服务",
        "CatalogCode": "jicfw",
        "ParentID": 2341233112383639,
        "Layer": 2,
        "Path": ",0,2,2341233112383639,",
        "Sequence": 1,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:26:18.517",
        "ID": 2341233280155799,
        "chileList": [
            {
                "IconText": "icon-zhengcefuwu",
                "ProjectContent": "",
                "ID": 2344335706161263,
                "Title": "政策服务",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:48:17.333",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:40:52.62",
                "Sequence": 1,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>提供政策的智能匹配和分步解读功能，全面整合国家/省市区的政策信息，企业和人才通过一个平台即可根据政策级别、发布部门、扶持方向、扶持力度、扶持行业等维度匹配出所需的政策，并可快速了解政策的扶持力度、申报条件、申报程序、提交材料、受理服务等关键信息，有效提升政策的知晓率和覆盖面。</p>"
                },
                "ContentTEXT": "提供政策的智能匹配和分步解读功能，全面整合国家/省市区的政策信息，企业和人才通过一个平台即可根据政策级别、发布部门、扶持方向、扶持力度、扶持行业等维度匹配出所需的政策，并可快速了解政策的扶持力度、申报条件、申报程序、提交材料、受理服务等关键信息，有效提升政策的知晓率和覆盖面。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/2ec1fc13-1252-46e6-8716-f9849576c84d.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-xiangmushenbao",
                "ProjectContent": "",
                "ID": 2344335135735919,
                "Title": "项目申报",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:47:43.26",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:40:55.847",
                "Sequence": 2,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>适用于有自主审批事项的园区（如扶持政策、扶持基金等）。建立项目线上申报、受理、评估、审批、跟踪、验收的全流程化监管机制，提高项目申报受理审批的工作效率。实现多主体、多条线、多部门的在线联动审批，有效提高项目信息交换与流转效率。通过对项目资金拨款、跟踪、审计等精细化管理，有效保障项目资金的落实及应用情况。</p>"
                },
                "ContentTEXT": "适用于有自主审批事项的园区（如扶持政策、扶持基金等）。建立项目线上申报、受理、评估、审批、跟踪、验收的全流程化监管机制，提高项目申报受理审批的工作效率。实现多主体、多条线、多部门的在线联动审批，有效提高项目信息交换与流转效率。通过对项目资金拨款、跟踪、审计等精细化管理，有效保障项目资金的落实及应用情况。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/3ea2a999-3786-4b43-885e-31a66902f1b5.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-gonggongziyuanyuding",
                "ProjectContent": "",
                "ID": 2344334615642171,
                "Title": "公共资源预订",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:47:12.397",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:40:59.563",
                "Sequence": 3,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>提供公共资源的在线查询与预订，包括工位、会议室、广告位、场地以及停车位的预订。可避免园区公共资源预订冲突，提高公共资源的使用率。并支持电商平台的接入，实现配套资源和服务预约购买、在线缴费（如会议室设备、办公家具等。</p>"
                },
                "ContentTEXT": "提供公共资源的在线查询与预订，包括工位、会议室、广告位、场地以及停车位的预订。可避免园区公共资源预订冲突，提高公共资源的使用率。并支持电商平台的接入，实现配套资源和服务预约购买、在线缴费（如会议室设备、办公家具等。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/3860ecc6-c38b-4f23-8761-9ec635d38d2e.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-yuanquhuodong",
                "ProjectContent": "",
                "ID": 2344333978108055,
                "Title": "园区活动",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:46:34.727",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:41:02.563",
                "Sequence": 4,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>以图文结合的方式展示活动的内容、时间、地点等相关信息，用户可通过活动标签来进行视图切换，有兴趣参与活动的用户可在线报名，用户参加具体活动时，可在线进行二维码签到，增加园区活动的曝光量，扩大活动的参与量，并对活动成果进行管理，对参会人员进行回访或跟踪。</p>"
                },
                "ContentTEXT": "以图文结合的方式展示活动的内容、时间、地点等相关信息，用户可通过活动标签来进行视图切换，有兴趣参与活动的用户可在线报名，用户参加具体活动时，可在线进行二维码签到，增加园区活动的曝光量，扩大活动的参与量，并对活动成果进行管理，对参会人员进行回访或跟踪。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/d171db4d-4804-4a21-a819-8a42086e5d69.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-wuyebaoxiu",
                "ProjectContent": "",
                "ID": 2344333458014359,
                "Title": "物业报修",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:46:03.947",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:41:04.867",
                "Sequence": 5,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>提供便捷的线上物业报修功能，针对存在问题的物业设施，企业和个人用户可以拍照上传，向园区物业部门发起报修申请，维修人员通过微信小程序在线抢单，维修完成后企业或个人对服务进行在线评价。</p>"
                },
                "ContentTEXT": "提供便捷的线上物业报修功能，针对存在问题的物业设施，企业和个人用户可以拍照上传，向园区物业部门发起报修申请，维修人员通过微信小程序在线抢单，维修完成后企业或个人对服务进行在线评价。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/e4346c24-b512-4801-8296-e82b9b588808.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-zhangdanchaxun",
                "ProjectContent": "",
                "ID": 2344332669485283,
                "Title": "账单查询",
                "Summary": "取代传统的“付款通知单”，同步“资产管理”模块的出账信息，定期推送企业电子账单，包括租金、物业费、水电费和其他收费事项，支持历史账单的查询，方便企业用户明确应缴费用的构成明细以及数额等信息。",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:45:16.223",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:41:06.157",
                "Sequence": 6,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>​取代传统的“付款通知单”，同步“资产管理”模块的出账信息，定期推送企业电子账单，包括租金、物业费、水电费和其他收费事项，支持历史账单的查询，方便企业用户明确应缴费用的构成明细以及数额等信息。</p>"
                },
                "ContentTEXT": "​取代传统的“付款通知单”，同步“资产管理”模块的出账信息，定期推送企业电子账单，包括租金、物业费、水电费和其他收费事项，支持历史账单的查询，方便企业用户明确应缴费用的构成明细以及数额等信息。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/9c5d3d40-2f8a-4250-bfd3-4563b579d134.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-fuwujishi",
                "ProjectContent": "",
                "ID": 2344331914510358,
                "Title": "服务集市",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:44:31.343",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:41:07.207",
                "Sequence": 7,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>建立以企业、人才为核心服务对象，集聚政府服务资源、园区服务资源和第三方服务资源，提供在线展示、查询与咨询，逐步实现生产性服务、生活性服务相融合的综合服务集市，涵盖创业投资、职业发展、创新交流、科技金融、生活配套等服务功能。</p>"
                },
                "ContentTEXT": "建立以企业、人才为核心服务对象，集聚政府服务资源、园区服务资源和第三方服务资源，提供在线展示、查询与咨询，逐步实现生产性服务、生活性服务相融合的综合服务集市，涵盖创业投资、职业发展、创新交流、科技金融、生活配套等服务功能。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/2e78e482-1a77-418b-9fdf-5f76b5980c6a.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-rencaigongyu",
                "ProjectContent": "",
                "ID": 2344330974986242,
                "Title": "人才公寓",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:43:35.34",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:41:09.25",
                "Sequence": 8,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>适用于设有人才公寓、公租房和租赁住房的园区。提供统一的租赁服务门户，建立透明化的轮候机制，实现在线申请、看房、预订、签约等闭环式服务体系的构建。全面统筹区域内多个运营主体房源，实现房源信息的动态更新与展示。建立申请、审批、轮候、运营一体化的业务运营机制，实现房源、客户、合同、财务的联动管理，并可结合物联网实现公寓管理与运营自动化，大力降低人才公寓管理及运营成本。</p>"
                },
                "ContentTEXT": "适用于设有人才公寓、公租房和租赁住房的园区。提供统一的租赁服务门户，建立透明化的轮候机制，实现在线申请、看房、预订、签约等闭环式服务体系的构建。全面统筹区域内多个运营主体房源，实现房源信息的动态更新与展示。建立申请、审批、轮候、运营一体化的业务运营机制，实现房源、客户、合同、财务的联动管理，并可结合物联网实现公寓管理与运营自动化，大力降低人才公寓管理及运营成本。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/04d5ecbe-a21d-45c9-a076-43c30d0b0cdf.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-luyandasai",
                "ProjectContent": "",
                "ID": 2344330337452263,
                "Title": "路演大赛",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:42:57.783",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:41:10.813",
                "Sequence": 9,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>适用于孵化器、众创空间等致力于创新培育的园区。实现创业项目的实时在线路演，打破空间与时间限制，为创业者创造更多机会，跨地域对接投资人、促进投融资项目落地，同时延伸线下活动，为创客提供多元化服务；基于大赛活动的社交特征，实现大赛活动会前、会中、会后全流程管理，沉淀价值数据。</p>"
                },
                "ContentTEXT": "适用于孵化器、众创空间等致力于创新培育的园区。实现创业项目的实时在线路演，打破空间与时间限制，为创业者创造更多机会，跨地域对接投资人、促进投融资项目落地，同时延伸线下活动，为创客提供多元化服务；基于大赛活动的社交特征，实现大赛活动会前、会中、会后全流程管理，沉淀价值数据。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/e4611d0c-8210-4028-97fb-b2c29d99e78e.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-yuanqushequan",
                "ProjectContent": "",
                "ID": 2344329548923096,
                "Title": "园区社圈",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:42:10.003",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:41:13.947",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>强化企企互动，促进园区内上下游企业的交流对接，以“线下活动与服务”加上“线上社交圈子”，无缝地将企业高管、白领、HR及服务主体（商户、场馆、机构等）对接在一起，围绕产业集聚、高管社交、兴趣同盟、技能出售和生活交友等话题，营造园区内部的生态氛围。</p>"
                },
                "ContentTEXT": "强化企企互动，促进园区内上下游企业的交流对接，以“线下活动与服务”加上“线上社交圈子”，无缝地将企业高管、白领、HR及服务主体（商户、场馆、机构等）对接在一起，围绕产业集聚、高管社交、兴趣同盟、技能出售和生活交友等话题，营造园区内部的生态氛围。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/ee2c2c40-65a5-44ba-8787-6f5c6899ab48.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-yuanqudianshang",
                "ProjectContent": "",
                "ID": 2344328659730590,
                "Title": "园区电商",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:41:17.65",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:41:15.417",
                "Sequence": 11,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>​适用于关注增值服务可持续运营的园区。园区电商围绕企业和人才两个维度的诉求，构建5公里服务圈，突出区域需求特征，弥补资源短板，助力产城社区的构建。平台将采用SIMR架构，支持园区商户不断接入，为园区建立统一响应机制，并实现个性化交易模式和优惠策略的设定，对订单、会员、积分、支付、结算等进行统筹管理。</p>"
                },
                "ContentTEXT": "​适用于关注增值服务可持续运营的园区。园区电商围绕企业和人才两个维度的诉求，构建5公里服务圈，突出区域需求特征，弥补资源短板，助力产城社区的构建。平台将采用SIMR架构，支持园区商户不断接入，为园区建立统一响应机制，并实现个性化交易模式和优惠策略的设定，对订单、会员、积分、支付、结算等进行统筹管理。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/ff2190b4-fe13-4f97-b19e-d2f26c10224c.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            },
            {
                "IconText": "icon-kefuguanli",
                "ProjectContent": "",
                "ID": 2344327938310174,
                "Title": "客服管理",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:40:34.333",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:41:18.84",
                "Sequence": 12,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>​面向园区客服部门或服务平台运营团队。提供一门式服务集中受理、服务工单派发、第三方服务监理、反馈的全流程控制。内置企业走访模板，规范走访过程，全面掌握企业动态信息。实现服务绩效管理，加强时效控制，提升企业满意度。</p>"
                },
                "ContentTEXT": "​面向园区客服部门或服务平台运营团队。提供一门式服务集中受理、服务工单派发、第三方服务监理、反馈的全流程控制。内置企业走访模板，规范走访过程，全面掌握企业动态信息。实现服务绩效管理，加强时效控制，提升企业满意度。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/7620eea5-8e7e-45ab-bfe3-7c6b229890ea.png"
                ],
                "CatalogueName": "集成服务",
                "CatalogueID": 2341233280155799,
                "CommentNum": 0
            }
        ]
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "招商引资",
        "CatalogCode": "zhaosyz",
        "ParentID": 2341233112383639,
        "Layer": 2,
        "Path": ",0,2,2341233112383639,",
        "Sequence": 2,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:26:26.397",
        "ID": 2341233414373542,
        "chileList": [
            {
                "IconText": "icon-zhaoshangditu",
                "ProjectContent": "",
                "ID": 2344340034683125,
                "Title": "招商地图",
                "Source": "IParkPush",
                "Views": 1,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:52:35.793",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:24.507",
                "Sequence": 1,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>通过全景地图的形式，面向企业、人才、公众进行园区品牌推广，可直观地查看园区产业定位、功能规划、优惠政策、交通优势、区位优势、产业和生活服务配套、重点项目和龙头企业等信息。招商地图作为园区的电子名片，能够提升园区的品牌形象，吸引优质企业和优秀人才的入驻，起到招商引流的作用。</p>"
                },
                "ContentTEXT": "通过全景地图的形式，面向企业、人才、公众进行园区品牌推广，可直观地查看园区产业定位、功能规划、优惠政策、交通优势、区位优势、产业和生活服务配套、重点项目和龙头企业等信息。招商地图作为园区的电子名片，能够提升园区的品牌形象，吸引优质企业和优秀人才的入驻，起到招商引流的作用。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/22639140-14f4-4649-895a-04859e9df919.png"
                ],
                "CatalogueName": "招商引资",
                "CatalogueID": 2341233414373542,
                "CommentNum": 0
            },
            {
                "IconText": "icon-shujudaping1",
                "ProjectContent": "",
                "ID": 2344339497812218,
                "Title": "数据大屏",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:52:03.09",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:26.07",
                "Sequence": 2,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p style=\"text-align:justify\">数据大屏是园区宣传推介的有效载体，通过与业务系统数据的紧密融合，能够将产业、空间、企业、人才、服务资源、物联网等抽象数据可视化，提供实时动态的图表展示，体现发展变迁和趋势预判，突出园区产业集聚、服务效能、资源整合等方面的优势。</p><p style=\"text-align:justify\">可放置在展厅、楼宇大厅、会客室等区域，在招商推介、人员来访、考察交流等场景进行直观宣讲。</p><p><br></p>"
                },
                "ContentTEXT": "数据大屏是园区宣传推介的有效载体，通过与业务系统数据的紧密融合，能够将产业、空间、企业、人才、服务资源、物联网等抽象数据可视化，提供实时动态的图表展示，体现发展变迁和趋势预判，突出园区产业集聚、服务效能、资源整合等方面的优势。可放置在展厅、楼宇大厅、会客室等区域，在招商推介、人员来访、考察交流等场景进行直观宣讲。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/0a5b07fc-2c21-49c3-8301-e1aa27de9473.png"
                ],
                "CatalogueName": "招商引资",
                "CatalogueID": 2341233414373542,
                "CommentNum": 0
            },
            {
                "IconText": "icon-shangjisaomiao",
                "ProjectContent": "",
                "ID": 2344338742837371,
                "Title": "商机扫描",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:51:18.917",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:27.287",
                "Sequence": 3,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>基于大数据服务能力，为园区的招商人员提供商机引进的辅助工具，通过产业图谱的构建，按行业、产业上下游属性扫描优t质企业，提供企业排行榜、商机推荐、企业基本信息披露等实用功能，使招商人员能快速找到潜在客户并对商机进行精准把控。</p>"
                },
                "ContentTEXT": "基于大数据服务能力，为园区的招商人员提供商机引进的辅助工具，通过产业图谱的构建，按行业、产业上下游属性扫描优t质企业，提供企业排行榜、商机推荐、企业基本信息披露等实用功能，使招商人员能快速找到潜在客户并对商机进行精准把控。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/bde55f99-37d5-46f8-b887-5482f7cd865b.png"
                ],
                "CatalogueName": "招商引资",
                "CatalogueID": 2341233414373542,
                "CommentNum": 0
            },
            {
                "IconText": "icon-fangtaikuaicha",
                "ProjectContent": "",
                "ID": 2344338105303150,
                "Title": "房态快查",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:50:40.297",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:28.91",
                "Sequence": 4,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>与“资产管理“模块紧密衔接，为园区的招商人员提供便捷的房源实时动态查询和预订工具，通过直观图的形式提供房源锁定/可租状态、计费面积、参考价格、入驻企业等信息，实现动态租控，即将到期提前告知，使招商人员能够及时响应客户需求，并支持在线预订/锁定意向房源，避免资源重复占用，效减少空置率。</p>"
                },
                "ContentTEXT": "与“资产管理“模块紧密衔接，为园区的招商人员提供便捷的房源实时动态查询和预订工具，通过直观图的形式提供房源锁定/可租状态、计费面积、参考价格、入驻企业等信息，实现动态租控，即将到期提前告知，使招商人员能够及时响应客户需求，并支持在线预订/锁定意向房源，避免资源重复占用，效减少空置率。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/52f54078-a2ca-447d-81bb-3eb9db781a3c.png"
                ],
                "CatalogueName": "招商引资",
                "CatalogueID": 2341233414373542,
                "CommentNum": 0
            },
            {
                "IconText": "icon-xiangmuzhuizong",
                "ProjectContent": "",
                "ID": 2344337434214652,
                "Title": "项目跟踪",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:50:00.503",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:30.39",
                "Sequence": 5,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>基于“招商漏斗”实现从招商线索发掘、商机集中报备、商机优先级排序到洽谈跟踪、进而签约落地全过程中的客户需求、意向房源、洽谈进度等信息管理，支持在线查看项目跟进记录，实现轻松复盘，为招商人员岗位变动的平滑交接提供保障，避免因项目周期过长而导致的信息流失，并体现客观的招商绩效。</p>"
                },
                "ContentTEXT": "基于“招商漏斗”实现从招商线索发掘、商机集中报备、商机优先级排序到洽谈跟踪、进而签约落地全过程中的客户需求、意向房源、洽谈进度等信息管理，支持在线查看项目跟进记录，实现轻松复盘，为招商人员岗位变动的平滑交接提供保障，避免因项目周期过长而导致的信息流失，并体现客观的招商绩效。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/afb48f27-f7f8-4f8b-ad6d-e0f6e99ffa21.png"
                ],
                "CatalogueName": "招商引资",
                "CatalogueID": 2341233414373542,
                "CommentNum": 0
            },
            {
                "IconText": "icon-xiangmuladi",
                "ProjectContent": "",
                "ID": 2344336662462708,
                "Title": "项目落地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:49:14.687",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:35.527",
                "Sequence": 6,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>为招商代办服务人员提供材料生成和节点管理工具，以入驻企业需求为核心，实现代办全流程实时提醒，确保待办业务处理高效、准时、无一遗漏。提供标准化企业章程生成功能，导出即可使用，缩短工作周期，减少人力投入，办理结束后的企业数据导入企业库，可作为企业库的数据来源之一。</p>"
                },
                "ContentTEXT": "为招商代办服务人员提供材料生成和节点管理工具，以入驻企业需求为核心，实现代办全流程实时提醒，确保待办业务处理高效、准时、无一遗漏。提供标准化企业章程生成功能，导出即可使用，缩短工作周期，减少人力投入，办理结束后的企业数据导入企业库，可作为企业库的数据来源之一。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/3e1e3a21-47c1-4af4-8551-87bde837d454.png"
                ],
                "CatalogueName": "招商引资",
                "CatalogueID": 2341233414373542,
                "CommentNum": 0
            }
        ]
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "资产经营",
        "CatalogCode": "zicjy",
        "ParentID": 2341233112383639,
        "Layer": 2,
        "Path": ",0,2,2341233112383639,",
        "Sequence": 3,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:26:33.707",
        "ID": 2341233531813929,
        "chileList": [
            {
                "IconText": "icon-kehuguanli",
                "ProjectContent": "",
                "ID": 2344347953529056,
                "Title": "客户管理",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:00:27.82",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:54.453",
                "Sequence": 1,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>BiPark构建了完整的企业信息标签体系，涵盖上百个企业信息字段，为园区提供标准化客户管理模板。基于动态模型的数据更新机制，实现“一企一档”，避免各部门客户数据碎片化。支持客户的分配，确保锁定唯一客服专员，并支持各类自定义报表生成及导出功能，满足多维度客户统计需求。</p>"
                },
                "ContentTEXT": "BiPark构建了完整的企业信息标签体系，涵盖上百个企业信息字段，为园区提供标准化客户管理模板。基于动态模型的数据更新机制，实现“一企一档”，避免各部门客户数据碎片化。支持客户的分配，确保锁定唯一客服专员，并支持各类自定义报表生成及导出功能，满足多维度客户统计需求。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/a9bbf86c-8668-4357-b77f-ec78835274e3.png"
                ],
                "CatalogueName": "资产经营",
                "CatalogueID": 2341233531813929,
                "CommentNum": 0
            },
            {
                "IconText": "icon-kongjianguanli",
                "ProjectContent": "",
                "ID": 2344347416657995,
                "Title": "空间管理",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:59:55.777",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:55.867",
                "Sequence": 2,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>​支持办公、商业、厂房、仓库、宿舍等多元空间产品的经营模式，实现地块、项目、楼宇、楼层、房间、工位六级精细化空间信息管理，动态呈现资产当前租售状态和入驻客户信息以及历史租售情况，通过房态共享，实现跨区域资源统筹，有效降低资产空置率，加速资产去化。</p>"
                },
                "ContentTEXT": "​支持办公、商业、厂房、仓库、宿舍等多元空间产品的经营模式，实现地块、项目、楼宇、楼层、房间、工位六级精细化空间信息管理，动态呈现资产当前租售状态和入驻客户信息以及历史租售情况，通过房态共享，实现跨区域资源统筹，有效降低资产空置率，加速资产去化。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/f2d85a1a-94dd-46d7-9611-4bfccad37360.png"
                ],
                "CatalogueName": "资产经营",
                "CatalogueID": 2341233531813929,
                "CommentNum": 0
            },
            {
                "IconText": "icon-yijianchuzhang",
                "ProjectContent": "",
                "ID": 2344346661683275,
                "Title": "一键出账",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:59:10.057",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:57.013",
                "Sequence": 3,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>可配置的合同模板，实现合同签约标准化，支持订租、租赁、期房、现房、租转售等多种经营形态。以“账单”为核心，支持水电费导入、临时费用添加，实现所有费用“一口出”。通过一键出账，将线上账单推送给企业，根据应实收账款自动进行欠费提醒。</p>"
                },
                "ContentTEXT": "可配置的合同模板，实现合同签约标准化，支持订租、租赁、期房、现房、租转售等多种经营形态。以“账单”为核心，支持水电费导入、临时费用添加，实现所有费用“一口出”。通过一键出账，将线上账单推送给企业，根据应实收账款自动进行欠费提醒。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/1bd4610a-f34a-48e4-b782-9b91275c72b4.png"
                ],
                "CatalogueName": "资产经营",
                "CatalogueID": 2341233531813929,
                "CommentNum": 0
            },
            {
                "IconText": "icon-zhinengjifei",
                "ProjectContent": "",
                "ID": 2344346074480829,
                "Title": "智能计费",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:58:35.9",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:42:58.827",
                "Sequence": 4,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>依据合同付费信息及费用参数设置，实现智能计费，内置多种单价算法，支持不同付费期限和付费方式下的计费，可满足混合模式下多元空间对合同管理和账务计算的需求，避免错账、漏账。</p>"
                },
                "ContentTEXT": "依据合同付费信息及费用参数设置，实现智能计费，内置多种单价算法，支持不同付费期限和付费方式下的计费，可满足混合模式下多元空间对合同管理和账务计算的需求，避免错账、漏账。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/6c46c9ac-4c61-4cb7-baf3-18ca4e336170.png"
                ],
                "CatalogueName": "资产经营",
                "CatalogueID": 2341233531813929,
                "CommentNum": 0
            },
            {
                "IconText": "icon-kuaisutianzhang",
                "ProjectContent": "",
                "ID": 2344345487278187,
                "Title": "快速填账",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:58:00.983",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:05.253",
                "Sequence": 5,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>实现业财一体化，确保资产与合同、企业、账款等信息实时关联。到账后快速调取客户所有应收账单，根据到账费用进行自动填账，无需人工核算每笔到账费用，确保100%精准对账。</p>"
                },
                "ContentTEXT": "实现业财一体化，确保资产与合同、企业、账款等信息实时关联。到账后快速调取客户所有应收账单，根据到账费用进行自动填账，无需人工核算每笔到账费用，确保100%精准对账。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/8a581a20-7491-4820-884e-d5faeb29fb39.png"
                ],
                "CatalogueName": "资产经营",
                "CatalogueID": 2341233531813929,
                "CommentNum": 0
            },
            {
                "IconText": "icon-zidongkaipiao",
                "ProjectContent": "",
                "ID": 2344344480645222,
                "Title": "自动开票",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:57:00.333",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:07.033",
                "Sequence": 6,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>便捷的开票登记，支持普通发票、专用发票两种发票类型。对接主流税控机，建立开票池，实现多张发票同时、自动开具。</p>"
                },
                "ContentTEXT": "便捷的开票登记，支持普通发票、专用发票两种发票类型。对接主流税控机，建立开票池，实现多张发票同时、自动开具。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/b5eb712f-f3a1-4f8b-bae6-bfb373fea0e3.png"
                ],
                "CatalogueName": "资产经营",
                "CatalogueID": 2341233531813929,
                "CommentNum": 0
            },
            {
                "IconText": "icon-gongchengxiangmuguanli",
                "ProjectContent": "",
                "ID": 2344343910220026,
                "Title": "工程项目管理",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:56:26.21",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:08.51",
                "Sequence": 7,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p style=\"text-align:justify\">主要适用于有基建、工程项目管理业务职能的园区，面向基建及工程部门。实现对工程项目从立项、工期安排、进度跟踪、竣工验收的全生命周期管理。提供对工程项目相关内容进行集中管理的功能，如项目变更历史、相关图档、相关合同、评估报告、供应商管理、分批次付费管理等，构筑完整的工程项目管理功能。</p><p style=\"text-align:justify\">通过甘特图实时监控和预警，加强对工期的监控，确保项目能够有序推进。</p><p><br></p>"
                },
                "ContentTEXT": "主要适用于有基建、工程项目管理业务职能的园区，面向基建及工程部门。实现对工程项目从立项、工期安排、进度跟踪、竣工验收的全生命周期管理。提供对工程项目相关内容进行集中管理的功能，如项目变更历史、相关图档、相关合同、评估报告、供应商管理、分批次付费管理等，构筑完整的工程项目管理功能。通过甘特图实时监控和预警，加强对工期的监控，确保项目能够有序推进。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/a6d94f89-c36d-44ed-9f62-9a97a9d17088.png"
                ],
                "CatalogueName": "资产经营",
                "CatalogueID": 2341233531813929,
                "CommentNum": 0
            },
            {
                "IconText": "icon-zhongdianxiangmutuijin",
                "ProjectContent": "",
                "ID": 2344343323017425,
                "Title": "重大项目推进",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T14:55:51.493",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:10.313",
                "Sequence": 8,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>适用于以一级土地开发为核心业务的开发区/高新区管委会及大型产业区。对签约项目在落地过程中的各项事项进行管理，可查看重大项目在推进过程中遇到的问题和需要协调的事项，能够根据实际情况作出及时的反馈，关联项目信息，提供历史资料、立项资料、审批资料的调阅，并可对推进事项进行流程化管理（项目立项、项目审核、项目验资、专项审批、工程建设、履约跟踪、竣工投产等），定期生成重大项目推进报告，促进跨部门协同和统筹，从而确保项目快速顺利推进。</p>"
                },
                "ContentTEXT": "适用于以一级土地开发为核心业务的开发区/高新区管委会及大型产业区。对签约项目在落地过程中的各项事项进行管理，可查看重大项目在推进过程中遇到的问题和需要协调的事项，能够根据实际情况作出及时的反馈，关联项目信息，提供历史资料、立项资料、审批资料的调阅，并可对推进事项进行流程化管理（项目立项、项目审核、项目验资、专项审批、工程建设、履约跟踪、竣工投产等），定期生成重大项目推进报告，促进跨部门协同和统筹，从而确保项目快速顺利推进。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/fdc32e7d-471a-4624-94d7-cbb05b407bd8.png"
                ],
                "CatalogueName": "资产经营",
                "CatalogueID": 2341233531813929,
                "CommentNum": 0
            },
            {
                "IconText": "icon-xietong",
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399374772535355,
                "Title": "全线协同",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T14:04:41.98",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T14:05:06.78",
                "Sequence": 9,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p style=\"text-align: justify;\">提供成熟的系统应用、功能表单和管理流程，内置各类常用的标准化表单。借助工作流，快速建立和优化内部工作流程的规则，推动制度有效地执行。实现业务流程的全程留痕，将流程、任务与绩效考核无缝衔接，确保考核的实时性与可追溯性。实现各部门、各项业务等复杂事务的数字化，园区管理者可实时查询、掌握全局的业务情况，实现管理的降维。</p>"
                },
                "ContentTEXT": "提供成熟的系统应用、功能表单和管理流程，内置各类常用的标准化表单。借助工作流，快速建立和优化内部工作流程的规则，推动制度有效地执行。实现业务流程的全程留痕，将流程、任务与绩效考核无缝衔接，确保考核的实时性与可追溯性。实现各部门、各项业务等复杂事务的数字化，园区管理者可实时查询、掌握全局的业务情况，实现管理的降维。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200720/04256879-9170-4717-994c-5b3de1f3555d.png"
                ],
                "CatalogueName": "资产经营",
                "CatalogueID": 2341233531813929,
                "CommentNum": 0
            }
        ]
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "运营看板",
        "CatalogCode": "yunykb",
        "ParentID": 2341233112383639,
        "Layer": 2,
        "Path": ",0,2,2341233112383639,",
        "Sequence": 4,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:26:41.977",
        "ID": 2341233666031662,
        "chileList": [
            {
                "IconText": "icon-quanjingshapan",
                "ProjectContent": "",
                "ID": 2344352835698789,
                "Title": "全景沙盘",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:05:18.843",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:39.6",
                "Sequence": 1,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>适用于大型产业园、开发区/高新区管委会等。为园区管理层或相关权限人员提供园区全景电子沙盘的可视化呈现，通过大数据的层层钻取，从园区总览（一级）—基地总览（二级）—楼宇总控（三级）—楼层总控（四级）—企业总控（五级），颗粒度逐步细化、层层深入，通过抽丝剥茧的手法将园区全景、企业风貌、服务资源、数据沉淀进行系统化的反映，基于高质量规划图/地图/三维模型的展现形式，使用户快速直观地了解区域全貌。</p>"
                },
                "ContentTEXT": "适用于大型产业园、开发区/高新区管委会等。为园区管理层或相关权限人员提供园区全景电子沙盘的可视化呈现，通过大数据的层层钻取，从园区总览（一级）—基地总览（二级）—楼宇总控（三级）—楼层总控（四级）—企业总控（五级），颗粒度逐步细化、层层深入，通过抽丝剥茧的手法将园区全景、企业风貌、服务资源、数据沉淀进行系统化的反映，基于高质量规划图/地图/三维模型的展现形式，使用户快速直观地了解区域全貌。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/2753ca65-5848-44b8-81a1-47164c65ff8c.png"
                ],
                "CatalogueName": "运营看板",
                "CatalogueID": 2341233666031662,
                "CommentNum": 0
            },
            {
                "IconText": "icon-shujumofang",
                "ProjectContent": "",
                "ID": 2344352315605144,
                "Title": "数据魔方",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:04:47.433",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:41.267",
                "Sequence": 2,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>基于数据磁铁实现园区各业务条线数据的沉淀，通过BI数据清洗和重组，提炼关键性园区运营指标数据，以任意维度进行自定义组合，可通过各类直观图表的形式展现，并支持即席报表的导出，实现数据的最大限度利用，挖掘数据的潜在关联和深层价值，以便实现跨部门数据共享，把握园区当前经营状况和发展趋势。</p>"
                },
                "ContentTEXT": "基于数据磁铁实现园区各业务条线数据的沉淀，通过BI数据清洗和重组，提炼关键性园区运营指标数据，以任意维度进行自定义组合，可通过各类直观图表的形式展现，并支持即席报表的导出，实现数据的最大限度利用，挖掘数据的潜在关联和深层价值，以便实现跨部门数据共享，把握园区当前经营状况和发展趋势。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/cc1fe11b-95b8-4b09-9954-96b0f355bf10.png"
                ],
                "CatalogueName": "运营看板",
                "CatalogueID": 2341233666031662,
                "CommentNum": 0
            },
            {
                "IconText": "icon-kuaibao",
                "ProjectContent": "",
                "ID": 2344351275417842,
                "Title": "运营快报",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:03:45.457",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:42.623",
                "Sequence": 3,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>BiPark运营快报定期推送，让园区管理者瞬息之间就能全面、精准了解园区当前实时运行状态，并迅速注意到预警事项，高效做出决策，真正体现“互联网速度”。集团总部和区域管委会则可以轻松查看分布在全国乃至全球，各个省市园区当前的运营状态，实现多分园、多基地的统筹管理。</p>"
                },
                "ContentTEXT": "BiPark运营快报定期推送，让园区管理者瞬息之间就能全面、精准了解园区当前实时运行状态，并迅速注意到预警事项，高效做出决策，真正体现“互联网速度”。集团总部和区域管委会则可以轻松查看分布在全国乃至全球，各个省市园区当前的运营状态，实现多分园、多基地的统筹管理。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/974d0858-3d05-4577-ae5b-aad150f4f3e1.png"
                ],
                "CatalogueName": "运营看板",
                "CatalogueID": 2341233666031662,
                "CommentNum": 0
            },
            {
                "IconText": "icon-qiyehuaxiang",
                "ProjectContent": "",
                "ID": 2344350738546930,
                "Title": "企业360°画像",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:03:13.593",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:43.86",
                "Sequence": 4,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>同步企业工商数据、股东、产品、证书、商标、专利、著作权、历史融资等信息，并结合园区招商、租售、服务、孵化、企业数据上报等业务数据，以及政府条线政策扶持、项目申报、产值税收等数据，构建企业360°全息画像，生成企业能力雷达图，洞察企业潜在风险、发展趋势、产业前景等，为精准服务和精准施策提供支撑。</p>"
                },
                "ContentTEXT": "同步企业工商数据、股东、产品、证书、商标、专利、著作权、历史融资等信息，并结合园区招商、租售、服务、孵化、企业数据上报等业务数据，以及政府条线政策扶持、项目申报、产值税收等数据，构建企业360°全息画像，生成企业能力雷达图，洞察企业潜在风险、发展趋势、产业前景等，为精准服务和精准施策提供支撑。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/814e6247-ed4f-46fd-8e6c-dbc74dfb15e1.png"
                ],
                "CatalogueName": "运营看板",
                "CatalogueID": 2341233666031662,
                "CommentNum": 0
            },
            {
                "IconText": "icon-xiaokongfenxi",
                "ProjectContent": "",
                "ID": 2344350134567116,
                "Title": "销控分析",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:02:37.553",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:46.363",
                "Sequence": 5,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>主要适用于有自有资产经营租售业务的园区。销控分析能够以平面图形式展现当前各楼宇、楼层、房间、工位的出租率、收缴率、企业数、建筑面积等租售情况，可通过查看历史变化趋势及时调整房源价格以适应市场的供需关系。</p>"
                },
                "ContentTEXT": "主要适用于有自有资产经营租售业务的园区。销控分析能够以平面图形式展现当前各楼宇、楼层、房间、工位的出租率、收缴率、企业数、建筑面积等租售情况，可通过查看历史变化趋势及时调整房源价格以适应市场的供需关系。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/b06b5fed-05d3-4e31-abb6-dc7f92afd94e.png"
                ],
                "CatalogueName": "运营看板",
                "CatalogueID": 2341233666031662,
                "CommentNum": 0
            },
            {
                "IconText": "icon-shuishoutongji",
                "ProjectContent": "",
                "ID": 2344349580918907,
                "Title": "税收统计",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:02:04.94",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:43:47.887",
                "Sequence": 6,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>适用于提供企业税收扶持的园区。系统支持一键导入国家税务局标准制式表格，即可总览园区企业税收情况；通过多维度统计分析，实现对税种完成情况、产税情况、同比环比完成情况的查看。定期生成企业税收排名，对排名浮动幅度较大的企业进行预警，提醒工作人员重点关注。</p>"
                },
                "ContentTEXT": "适用于提供企业税收扶持的园区。系统支持一键导入国家税务局标准制式表格，即可总览园区企业税收情况；通过多维度统计分析，实现对税种完成情况、产税情况、同比环比完成情况的查看。定期生成企业税收排名，对排名浮动幅度较大的企业进行预警，提醒工作人员重点关注。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/67d011ba-3a92-4521-9020-342b2c271212.png"
                ],
                "CatalogueName": "运营看板",
                "CatalogueID": 2341233666031662,
                "CommentNum": 0
            }
        ]
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "智能应用",
        "CatalogCode": "zhinyy",
        "ParentID": 2341233112383639,
        "Layer": 2,
        "Path": ",0,2,2341233112383639,",
        "Sequence": 6,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:27:01.127",
        "ID": 2341234001576102,
        "chileList": [
            {
                "IconText": "icon-zhinengmenjin",
                "ProjectContent": "",
                "ID": 2344362499375134,
                "Title": "智能门禁",
                "Source": "IParkPush",
                "Views": 7,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:14:54.547",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:44:31.43",
                "Sequence": 1,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>BiPark平台能够可实现智慧通行，针对员工、访客、陌生人给予不同的通行权限；同时在不同的场景结合下，实现智能考勤、会议签到、访客接待等功能，相对于传统门禁更加安全、高效、智能，用户体验更好。</p>"
                },
                "ContentTEXT": "BiPark平台能够可实现智慧通行，针对员工、访客、陌生人给予不同的通行权限；同时在不同的场景结合下，实现智能考勤、会议签到、访客接待等功能，相对于传统门禁更加安全、高效、智能，用户体验更好。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/335f2c40-2b68-4c6a-b66a-1f522886e9f5.png"
                ],
                "CatalogueName": "智能应用",
                "CatalogueID": 2341234001576102,
                "CommentNum": 0
            },
            {
                "IconText": "icon-zhinengfangke",
                "ProjectContent": "",
                "ID": 2344361928949846,
                "Title": "智能访客",
                "Source": "IParkPush",
                "Views": 3,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:14:20.257",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:44:32.607",
                "Sequence": 2,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>访客可通过BiPark平台提前预约拜访，也可现场自助登记。管理员在后台进行预约审核后，系统自动开放访客门禁权限，当访客到访时，智能门禁自动识别，通知被访人接待访客，拜访结束后，访客来访记录智能统计，数据准确全面。</p>"
                },
                "ContentTEXT": "访客可通过BiPark平台提前预约拜访，也可现场自助登记。管理员在后台进行预约审核后，系统自动开放访客门禁权限，当访客到访时，智能门禁自动识别，通知被访人接待访客，拜访结束后，访客来访记录智能统计，数据准确全面。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/97b4f4b0-5323-42b3-90bb-35498e7837e6.png"
                ],
                "CatalogueName": "智能应用",
                "CatalogueID": 2341234001576102,
                "CommentNum": 0
            },
            {
                "IconText": "icon-zhinengtingche",
                "ProjectContent": "",
                "ID": 2344361425633310,
                "Title": "智能停车",
                "Source": "IParkPush",
                "Views": 1,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:13:50.547",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:44:33.703",
                "Sequence": 3,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>​BiPark智能停车具有车位感知、车辆识别、车位引导、反向寻车、多元支付等功能，满足园区不同的收费标准、方式和模式，解放园区停车区域的人力成本，提供车辆通行效率，给出入人员便捷、无感的用户体验。</p>"
                },
                "ContentTEXT": "​BiPark智能停车具有车位感知、车辆识别、车位引导、反向寻车、多元支付等功能，满足园区不同的收费标准、方式和模式，解放园区停车区域的人力成本，提供车辆通行效率，给出入人员便捷、无感的用户体验。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/69afd4d0-71a2-4a78-a941-d544fc55fc76.png"
                ],
                "CatalogueName": "智能应用",
                "CatalogueID": 2341234001576102,
                "CommentNum": 0
            },
            {
                "IconText": "icon-zhinenghuiyishi",
                "ProjectContent": "",
                "ID": 2344360922316876,
                "Title": "智能会议室",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:13:20.73",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:44:35.123",
                "Sequence": 4,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>支持会议室资源在线查看及预订，BiPark平台联动会议展示屏，直接查看当天会议安排。无线投屏、智能白板、视频会议等可提升会议体验，会议结束或提前取消，系统自动释放会议室，实现会议室资源利用率大幅度提高。</p>"
                },
                "ContentTEXT": "支持会议室资源在线查看及预订，BiPark平台联动会议展示屏，直接查看当天会议安排。无线投屏、智能白板、视频会议等可提升会议体验，会议结束或提前取消，系统自动释放会议室，实现会议室资源利用率大幅度提高。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/6f3bfb0d-8e97-4b7b-ba77-babcbf7d6886.png"
                ],
                "CatalogueName": "智能应用",
                "CatalogueID": 2341234001576102,
                "CommentNum": 0
            },
            {
                "IconText": "icon-zhinengshitang",
                "ProjectContent": "",
                "ID": 2344360419000554,
                "Title": "智慧食堂",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:12:50.643",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:44:36.8",
                "Sequence": 5,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>BiPark平台智慧食堂支持在线查看食堂客流量和备餐菜品，有效错开用餐高峰，避免排长队和拥堵状况，同时支持多元支付方式，简单便捷。</p>"
                },
                "ContentTEXT": "BiPark平台智慧食堂支持在线查看食堂客流量和备餐菜品，有效错开用餐高峰，避免排长队和拥堵状况，同时支持多元支付方式，简单便捷。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/60e15068-d1fb-47a4-9a1b-0eab15a39200.png"
                ],
                "CatalogueName": "智能应用",
                "CatalogueID": 2341234001576102,
                "CommentNum": 0
            },
            {
                "IconText": "icon-zhihuinengyuan",
                "ProjectContent": "",
                "ID": 2344359882129474,
                "Title": "智慧能源",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:12:18.19",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-02T15:44:38.757",
                "Sequence": 6,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>基于智能水电表及IOT设备，远程采集同步能耗实时读数，无需人工抄表。用户可在BiPark平台APP端实时查看能源使用量，在线进行水电账单缴纳，运营人员可全局查看能源同比、环比情况，进行能耗分析，优化能源使用。</p>"
                },
                "ContentTEXT": "基于智能水电表及IOT设备，远程采集同步能耗实时读数，无需人工抄表。用户可在BiPark平台APP端实时查看能源使用量，在线进行水电账单缴纳，运营人员可全局查看能源同比、环比情况，进行能耗分析，优化能源使用。",
                "ImgUrls": [
                    "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/UserFile/Files/Attach/20200605/89a435ca-8aa7-4891-a14f-d38a0c9c3cb1.png"
                ],
                "CatalogueName": "智能应用",
                "CatalogueID": 2341234001576102,
                "CommentNum": 0
            }
        ]
    }
]

export namespace Software {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, softwareModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.software;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/software`);
        }
        componentDidMount() {
            this.dispatch("input", { honorIndex: 5});
            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });
            $(".box-type2 ul li").hover(
                function() {
                    let idx = $(this).index();
                    $(".bi-project-list").each(function() {
                        if ($(this).index() === idx) $(this).show();
                        else $(this).hide();
                    });
                },
                function() {}
            );
        }
        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 770) {
                this.dispatch("input", { honorIndex: 1});
            } else {
                this.dispatch("input", { honorIndex: 5 });
            }
        }


        renderResource() {
            return (
                <div className="block-content company-content">
                    <div className="container">
                        <div className="second-title">
                            <span>了解软件</span>
                        </div>
                        <div className="company-info">
                            瑞谷软件成立于2011年，13年来聚焦园区数字化赛道，致力于将互联网、大数据、物联网、云计算、人工智能等科技手段赋能园区实际业务场景，
                            通过数字网络将园区基础设施、智能硬件、空间载体、企业人才、服务资源、产业配套等生态要素全面联通，并融合一流园区管理理念和运行机制，以技术革命助推园区运营模式创新，
                            将园区构建成为全域感知的生命体，并依托智慧大脑实现不断进化。
                        </div>
                    </div>
                </div>
            )
        }

        renderSystem() {
            return (
                <div className="bi-park">
                    <div className="rows">
                        <div className="box-type1">
                            <div className="bi-title">BiPark是什么</div>
                            <div className="text1">
                                智慧园区应用集成平台，全场景数字化转型工具
                            </div>
                            <img className="yinhao" src={"./assets/images/guanw/yh.png"} alt="" />
                            <div className="text2 ">
                                基于上百个园区信息化项目实践经验，提供<span className="primary-color">150+</span>
                                成熟应用构件，以类似APP Store的形式为不同体量、不同类型、不同组织架构、不同运营模式的各类园区提供可自由组合的信息化解决方案。
                            </div>
                            <a
                                className="btn2"
                                target="_blank"
                                href="http://www.bitech.cn/Article/BiPark.aspx"
                            >
                                了解典型应用
                            </a>
                        </div>
                    </div>
                    <div className="rows">
                        <div className="animate-imgbox">
                            <img src={"./assets/images/guanw/rj-img.png"} alt="" />
                        </div>
                    </div>
                    <div className="rows">
                        <div className="box-type2">
                            <div className="tit ">产品</div>
                            <ul className="list">
                                {DataCatalog &&
                                    DataCatalog.map((item, i) => {
                                        return (
                                            <li className="" key={i}>
                                                {item.CatalogName}
                                            </li>
                                        );
                                    })}
                            </ul>
                        </div>
                    </div>
                    {this.renderProductContent()}
                </div>
            )
        }
        renderProductContent(): JSX.Element | null {
            return (
                <div className="rows">
                    {DataCatalog &&
                        DataCatalog.map((item, i) => {
                            return (
                                <ul className="bi-project-list" key={i}>
                                    {item.chileList &&
                                        item.chileList.map((data, y) => {
                                            return (
                                                <li key={y}>
                                                    <i className={"icon " + data.IconText} />
                                                    <span>{data.Title}</span>
                                                </li>
                                            );
                                        })}
                                </ul>
                            );
                        })}
                </div>
            );
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/guanw/rgrj-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">瑞谷软件</div>
                                <div className="banner-text-name2 mt25">
                                    智慧园区全场景解决方案提供商
                                </div>
                            </div>}
                        />
                        {this.renderResource()}
                        {this.renderSystem()}


                        {this.renderEmbeddedView(BackTopBox.Page)}
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.software]);
}
